module.exports = __webpack_public_path__ + "img/img2.46a081f.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/saasIntroduction/img2.png
// module id = +7BI
// module chunks = 171